import { PageLink as Link } from 'src/app/AppAuth/PageLink'
import { EroDarkEastImg } from 'src/components/Icons/Brand'
import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'

export const EroIcon = styled(EroDarkEastImg)<{
  $isSmall?: boolean
}>`
  flex-direction: column;

  ${({ $isSmall }) => ($isSmall ? `margin-bottom: 0` : `margin-bottom: 1em`)};
  ${({ $isSmall }) => ($isSmall ? `height: 28px` : `height: 40px`)};
  ${({ $isSmall }) => ($isSmall ? `width: 28px` : `width: 40px`)};
`

export const QASourcesContainer = styled.div<{
  $mt?: number
  $isAgentChat?: boolean
}>`
  display: flex;
  flex-direction: ${({ $isAgentChat }) => ($isAgentChat ? 'row' : 'column')};
  gap: 4px;
  line-height: 150%;
  font-size: 14px;
  color: ${palette.neutral[600]};
  margin-top: ${({ $mt }) => ($mt !== undefined ? `${$mt}px` : '12px')};
  ${({ $isAgentChat }) =>
    $isAgentChat &&
    css`
      gap: 12px;
      flex-wrap: wrap;
    `}
`

export const PageNumberLabel = styled.div<{ $isAgentChat?: boolean }>`
  display: inline;
  font-size: ${({ $isAgentChat }) => ($isAgentChat ? '12px' : '14px')};
  color: ${({ $isAgentChat }) =>
    $isAgentChat ? palette.neutral[600] : palette.neutral[200]};
  text-decoration: none;
`

export const PageNumberItemLabel = styled.div<{ $isAgentChat?: boolean }>`
  text-decoration: underline;
  cursor: pointer;
  min-width: 10px;
  display: inline-block;
  color: ${({ $isAgentChat }) =>
    $isAgentChat ? palette.neutral[600] : palette.neutral[200]};
`

export const PageNumberItemLabelLink = styled(Link)<{ $isAgentChat?: boolean }>`
  color: ${palette.neutral[600]};
  &:visited {
    color: ${palette.neutral[600]};
  }
`
